/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';
import type { UnaccentTextSearch } from './UnaccentTextSearch';
import {
    UnaccentTextSearchFromJSON,
    UnaccentTextSearchFromJSONTyped,
    UnaccentTextSearchToJSON,
} from './UnaccentTextSearch';

/**
 * 
 * @export
 * @interface LieuFormationSelectorSearch
 */
export interface LieuFormationSelectorSearch {
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof LieuFormationSelectorSearch
     */
    nom?: UnaccentTextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof LieuFormationSelectorSearch
     */
    contact?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof LieuFormationSelectorSearch
     */
    localite?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof LieuFormationSelectorSearch
     */
    telephone?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof LieuFormationSelectorSearch
     */
    email?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof LieuFormationSelectorSearch
     */
    enseigne?: TextSearch;
    /**
     * 
     * @type {number}
     * @memberof LieuFormationSelectorSearch
     */
    idsiegeSocial?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LieuFormationSelectorSearch
     */
    numeroBce?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof LieuFormationSelectorSearch
     */
    excludedLieuFormationIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof LieuFormationSelectorSearch
     */
    selectedLieuFormationIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof LieuFormationSelectorSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof LieuFormationSelectorSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof LieuFormationSelectorSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LieuFormationSelectorSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof LieuFormationSelectorSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof LieuFormationSelectorSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the LieuFormationSelectorSearch interface.
 */
export function instanceOfLieuFormationSelectorSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LieuFormationSelectorSearchFromJSON(json: any): LieuFormationSelectorSearch {
    return LieuFormationSelectorSearchFromJSONTyped(json, false);
}

export function LieuFormationSelectorSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): LieuFormationSelectorSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom': !exists(json, 'nom') ? undefined : UnaccentTextSearchFromJSON(json['nom']),
        'contact': !exists(json, 'contact') ? undefined : TextSearchFromJSON(json['contact']),
        'localite': !exists(json, 'localite') ? undefined : TextSearchFromJSON(json['localite']),
        'telephone': !exists(json, 'telephone') ? undefined : TextSearchFromJSON(json['telephone']),
        'email': !exists(json, 'email') ? undefined : TextSearchFromJSON(json['email']),
        'enseigne': !exists(json, 'enseigne') ? undefined : TextSearchFromJSON(json['enseigne']),
        'idsiegeSocial': !exists(json, 'idsiegeSocial') ? undefined : json['idsiegeSocial'],
        'numeroBce': !exists(json, 'numeroBce') ? undefined : json['numeroBce'],
        'excludedLieuFormationIds': !exists(json, 'excludedLieuFormationIds') ? undefined : json['excludedLieuFormationIds'],
        'selectedLieuFormationIds': !exists(json, 'selectedLieuFormationIds') ? undefined : json['selectedLieuFormationIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function LieuFormationSelectorSearchToJSON(value?: LieuFormationSelectorSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom': UnaccentTextSearchToJSON(value.nom),
        'contact': TextSearchToJSON(value.contact),
        'localite': TextSearchToJSON(value.localite),
        'telephone': TextSearchToJSON(value.telephone),
        'email': TextSearchToJSON(value.email),
        'enseigne': TextSearchToJSON(value.enseigne),
        'idsiegeSocial': value.idsiegeSocial,
        'numeroBce': value.numeroBce,
        'excludedLieuFormationIds': value.excludedLieuFormationIds,
        'selectedLieuFormationIds': value.selectedLieuFormationIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

